import { NewPatientQueryKey, UserInfo } from 'api/common/routes'
import useAxiosWithAuth from 'api/useAxiosWithAuth'
import { useQuery } from 'react-query'
import { User } from './useUser'

interface UseNewPatientInterface {
  user?: User
  isLoading: boolean
}

const useNewPatient = (): UseNewPatientInterface => {
  const axiosWithAuth = useAxiosWithAuth()

  const fetchUser = async (): Promise<User | undefined> => {
    const res = await axiosWithAuth.get<User>(
      `${process.env.REACT_APP_SERVER_URL}${UserInfo}`
    )

    const user = res.data

    if (user && user.sourceHealthId) {
      // user with member exists
      return user
    } else {
      throw new Error('Not ready yet')
    }
  }

  const { data: user, isLoading } = useQuery(NewPatientQueryKey, fetchUser, {
    retry: 8,
    retryDelay: (attempt) => 500 * 1.5 ** attempt,
  })

  return { user, isLoading }
}

export default useNewPatient
